import type { FaireProductEntity } from "../../entity_types/product";

export const p_ff9whq8b2u: FaireProductEntity = {
  token: "p_ff9whq8b2u",
  type: "product",
  name: "Little Farmhouse Sticker Sheet",
  brandName: "STICKII",
  imageUrl:
    "https://cdn.faire.com/fastly/4363b370ffa8998e8b22bb78319b6980fdb4204b93c4294e3bffc5c19b6a9f76.jpeg",
  priceDollars: 1.7,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2b720ba727b8228e91991565b1fa56a889327e7a28ff9be2bb7ea2d4ef0250c5.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
